<nb-card class="offer-request-card">
	<nb-card-body class="overflow-visible">
		<form [formGroup]="form">
			<div class="row-wrapper">
				<div>
					<label class="company-input-label label-row">{{ 'transfer-questions-details.label' | translate }}</label>
				</div>
			</div>

			<div class="form-row margin-bottom20 wrap">
				<div class="cb-select">
					<nb-radio-group id="has-dekra-{{product.standard.name.toLowerCase()}}-certificate-radio-group"
									name="has-dekra-{{product.standard.name.toLowerCase()}}-certificate"
									[status]="isInvalid('hasDekraCertificate') ? 'danger' : 'primary'" [disabled]="shouldDisableRadio('hasDekraCertificate') || blocked"
									formControlName="{{fullControlName('hasDekraCertificate')}}" [attr.formControlName]="fullControlName('hasDekraCertificate')"
									(valueChange)="updateFormControl('hasDekraCertificate', $event)">
						<nb-radio name="has-dekra-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="true">DEKRA</nb-radio>
						<nb-radio name="has-dekra-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="false">{{ 'common.other' | translate }}</nb-radio>
					</nb-radio-group>
					@if (isInvalid('hasDekraCertificate')) {
						<div class="validation-message"
						>{{ getValidationErrors('hasDekraCertificate') | async }}
						</div>
					}
				</div>
				@if (product.standard.hasDekraCertificate != null && product.standard.hasDekraCertificate == false) {
					<div class="other-cb" [attr.data-test-id]="'other-cb-' + product.standard.name">
						<ng-select (change)="onCbChange($event)" [items]="certificationBodies" [searchFn]="searchCertificationBodiesFn" [notFoundText]="'common.not-found' | translate"
								   [inputAttrs]="{autocomplete: 'user-password'}" [clearable]="false"
								   [dropdownPosition]="'bottom'" [placeholder]="'common.select' | translate" [formControlName]="fullControlName('otherCbName')"
								   [attr.formControlName]="fullControlName('otherCbName')"></ng-select>
						@if (isInvalid('otherCbName')) {
							<div class="validation-message">{{ getValidationErrors('otherCbName') | async }}</div>
						}
					</div>
				}
			</div>
			@if (!otherCbChosen && !product.standard.hasDekraCertificate && product.standard.customCb) {
				<div class="form-row custom-cb margin-bottom20">
					<input type="text" nbInput fullWidth [formControlName]="fullControlName('customCbName')" [attr.formControlName]="fullControlName('customCbName')"
						   [placeholder]="'transfer-questions-details.other-cb-placeholder' | translate">
					@if (isInvalid('customCbName')) {
						<div class="validation-message">{{ getValidationErrors('customCbName') | async }}</div>
					}
				</div>
			}

			@if (product.standard.hasDekraCertificate || dekraTypedAsCustomCb) {
				<div class="row-wrapper margin-bottom20">
					<div>
            <span class="redirection-message">
              {{ 'transfer-questions-details.renewal-info' | translate }} <a [href]="'mailto:' + ('common.sales-contact-email.' + order.clientCountry | translate)"
																			 target="_blank">{{ 'common.sales-contact-email.' + order.clientCountry | translate }}</a>
            </span>
					</div>
				</div>
			}

			<div class="row-wrapper">
				<div>
					<label class="company-input-label label-row" for="current-certification-last-audit-event-radio-group">
						{{ 'transfer-questions-details.last-audit' | translate }}
					</label>
				</div>
			</div>
			<div class="row-wrapper">
				<div>
					<nb-radio-group style="flex-wrap:wrap;" id="current-certification-last-audit-event-radio-group" name="currentCertificationLastAuditEvent"
									[status]="isInvalid('lastAuditEvent') ? 'danger' : 'primary'" [disabled]="shouldDisableRadio('lastAuditEvent')"
									[formControlName]="fullControlName('lastAuditEvent')" [attr.formControlName]="fullControlName('lastAuditEvent')"
									(valueChange)="updateFormControl('lastAuditEvent', $event)" [attr.data-test-id]="'current-certification-' + product.standard.name">
						<nb-radio name="currentCertificationLastAuditEventRadio" [value]="INITIAL_CERTIFICATION_AUDIT_TYPE"
								  [attr.data-test-id]="'current-certification-' + product.standard.name + '_' + INITIAL_CERTIFICATION_AUDIT_TYPE">{{ 'audit-type.INITIAL_CERTIFICATION' | translate }}
						</nb-radio>
						<nb-radio name="currentCertificationLastAuditEventRadio" [value]="SURVEILLANCE_1_AUDIT_TYPE"
								  [attr.data-test-id]="'current-certification-' + product.standard.name + '_' + SURVEILLANCE_1_AUDIT_TYPE">{{ 'audit-type.SURVEILLANCE_1' | translate }}
						</nb-radio>
						<nb-radio name="currentCertificationLastAuditEventRadio" [value]="SURVEILLANCE_2_AUDIT_TYPE"
								  [attr.data-test-id]="'current-certification-' + product.standard.name + '_' + SURVEILLANCE_2_AUDIT_TYPE">{{ 'audit-type.SURVEILLANCE_2' | translate }}
						</nb-radio>
						<nb-radio name="currentCertificationLastAuditEventRadio" [value]="RECERTIFICATION_AUDIT_TYPE"
								  [attr.data-test-id]="'current-certification-' + product.standard.name + '_' + RECERTIFICATION_AUDIT_TYPE">{{ 'audit-type.RECERTIFICATION' | translate }}
						</nb-radio>
					</nb-radio-group>
					@if (isInvalid('lastAuditEvent')) {
						<div class="validation-message">{{ getValidationErrors('lastAuditEvent') | async }}</div>
					}
				</div>
			</div>
		</form>
	</nb-card-body>
</nb-card>
